import { create } from 'zustand';

const useSelectionsStore = create((set) => ({
  selections: {
    codeje: '',
    course: '',
  },
  setSelections: (selections) => set({ selections })
}))

export default useSelectionsStore;